import { useEffect } from 'react'
import { captureException } from '@sentry/nextjs'

import { removedExpiredEvents } from '~/behavior-tracking/utility/view-event-logs.utility'

const CLEANUP_TASK_DELAY = 10_000

export default function useStoredEventCleanUp(userId: number | null): void {
  useEffect(() => {
    if (userId == null) {
      return
    }

    const timeoutId = setTimeout(() => {
      removedExpiredEvents().catch((err) => {
        captureException(err, { tags: { feature: 'view-tracking', action: 'clean-expired-events' } })
        console.error('Failed to clean up expired page view events', err)
      })
    }, CLEANUP_TASK_DELAY)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [userId])
}
